import format from 'date-fns/format';
import React from 'react';

import { Separator, Stack, Tag } from '@eluve/components';
import { useTranslation } from '@eluve/i18n';

export type TranscriptTimestampAction = 'started' | 'resumed' | 'paused';

export interface TranscriptTimestampDividerProps {
  timestamp?: string;
  action?: TranscriptTimestampAction;
  className?: string;
  dateFormat?: string;
}

export const TranscriptTimestampDivider: React.FC<
  TranscriptTimestampDividerProps
> = ({
  className,
  timestamp = new Date().toISOString(),
  action = 'paused',
  dateFormat,
}) => {
  const { t } = useTranslation();
  const date = new Date(timestamp);

  const formattedDate = dateFormat
    ? format(date, dateFormat)
    : format(date, 'P');
  const formattedTime = format(date, 'p');

  const key =
    action === 'started'
      ? 'appointment.transcript.sessionStartedAt'
      : action === 'resumed'
        ? 'appointment.transcript.sessionResumedAt'
        : 'appointment.transcript.sessionPausedAt';
  const label = t(key, { date: formattedDate, time: formattedTime });

  return (
    <Stack className={className} direction="horizontal">
      <Separator className="flex-1" />
      <Tag
        size="s"
        color="gray"
        pill
        label={label}
        className="whitespace-nowrap"
      />
      <Separator className="flex-1" />
    </Stack>
  );
};
